<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }" :key="$store.state.key">
    <v-app-bar app clipped-left clipped-right :color="isDark ? 'dark' : 'primary'" dark tile flat>
      <!-- <v-app-bar-nav-icon exact :to="{ name: 'home' }">
        <template slot="default">
          <img src="/images/logo_small_white.svg"  width="30" height="30" />
        </template>
      </v-app-bar-nav-icon> -->
      <router-link to="/" exact class="d-none d-lg-block ms-3"><v-img src="/images/sky_logo_white.svg" width="150" height="30" cover /></router-link>
      <v-spacer></v-spacer>
      <v-tabs centered>
        <template v-for="(item, i) in menu">
          <v-tab exact :to="{ name: item.route }" :key="i">{{ item.title }}</v-tab>
        </template>
      </v-tabs>
      <v-spacer></v-spacer>
      <ax-button icon="mdi-theme-light-dark" tooltip="Toggle light/dark modes" rounded @clicked="toggleDarkMode" />
      <v-btn icon @click="refreshPage"><v-icon>mdi-refresh</v-icon></v-btn>
      <!-- <v-btn icon :to="help_route"><v-icon>mdi-help-circle-outline</v-icon></v-btn> -->
      <v-btn icon v-if="isStaff || isSuper" :href="`${server}/admin/`" target="_blank"><v-icon>mdi-cog-outline</v-icon></v-btn>
      <v-btn icon :to="{ name: 'logout' }"><v-icon>mdi-exit-to-app</v-icon></v-btn>
    </v-app-bar>
    <template v-if="route_contains('help')">
      <navbar :mini="mini"></navbar>
      <v-main :class="[isDark ? 'grey darken-4' : 'white']">
        <v-container fluid class="py-16">
          <v-responsive max-width="960" class="mx-auto help">
            <slot></slot>
          </v-responsive>
        </v-container>
      </v-main>
    </template>
    <template v-else>
      <v-main>
        <slot></slot>
      </v-main>
    </template>
    <v-footer app class="caption" v-if="!route_contains('help')">
      <span>&copy; AlphaX Decision Sciences. All Rights Reserved.</span>
      <v-spacer></v-spacer>
      <span>{{ version }}</span>
      <v-divider vertical class="mx-2"></v-divider>
      <span>{{ user.name }}</span>
      <template v-if="user.quota && user.quota > 0">
        <v-divider vertical class="mx-2"></v-divider>
        <div class="d-flex align-center" style="min-width: 200px;">
          <span class="me-2 text-no-wrap">{{ user.wells }}/{{ user.quota }} wells</span>
          <v-progress-linear 
            :value="(user.wells / user.quota) * 100" 
            rounded
            :color="quotaColor"
          ></v-progress-linear>
        </div>
      </template>
      <v-divider vertical class="mx-2"></v-divider>
      <v-icon :color="online ? 'green' : 'red'" size="20">
        {{ online ? "mdi-check-circle" : "mdi-alert-circle" }}
      </v-icon>
    </v-footer>
    <v-overlay :value="this.isBusy" :opacity="0.75">
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <div class="mt-5">Processing Request</div>
      </div>
    </v-overlay>
    <snackbar></snackbar>
  </v-app>
</template>
<script>
import Snackbar from "@/components/snackbar"
import Navbar from "@/components/navbar"
import AxButton from "@/components/button"
import Users from "@/api/users"
export default {
  name: "Page",
  components: {
    Snackbar,
    Navbar, 
    AxButton
  },
  data() {
    return {
      mini: true,
      drawer: false,
      menu: [
        { title: 'Home', icon: 'mdi-home', route: 'home', exact: false, },
        { title: 'Files', icon: 'mdi-file-document', route: 'fileList', exact: false },
        { title: 'Datasets', icon: 'mdi-database', route: 'datasetList', exact: false },
        { title: 'Predictions', icon: 'mdi-finance', route: 'predictionList', exact: false },
        { title: 'Exports', icon: 'mdi-format-columns', route: 'exportList', exact: false },
        { title: 'Reports', icon: 'mdi-file-chart', route: 'reportList', exact: false },
      ],
    }
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light"
    },
    connection() {
      return this.online ? "signal" : "signal-slash"
    },
    quotaColor() {
      if (!this.user || !this.user.quota || this.user.quota === 0) {
        return 'primary'
      }
      if (this.user.wells > this.user.quota) {
        return 'error'
      }
      // const ratio = this.user.wells / this.user.quota
      // if (ratio > 0.9) {
      //   return 'error'
      // }
      // if (ratio > 0.7) {
      //   return 'error'
      // }
      return 'primary'
    },
    help_route() {
      if (this.route_contains('help')) {
        return { name: 'home' }
      }
      else {
        if (this.route_contains('files')) return { path: '/help/files', hash: this.$route.name }
        else if (this.route_contains('datasets')) return { path: '/help/datasets', hash: this.$route.name }
        else if (this.route_contains('predictions')) return { path: '/help/predictions', hash: this.$route.name }
        else if (this.route_contains('applications')) {
          if (this.route_contains('forecasting')) return { path: '/help/applications/forecasting' }
          else if (this.route_contains('virtualwell')) return { path: '/help/applications/virtualwell' }
          return { path: '/help/applications' }
        }
        else return { path: '/help' }
      }
    }
  },
  mounted() {
    this.$vuetify.theme.dark = this.$store.state.dark
    this.$store.commit('setBusy', false)
  },
  methods: {
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.$store.commit('setDark', this.$vuetify.theme.dark)
    },
    refreshPage() {
      // Refresh user data
      if (this.user && this.user.username) {
        Users.retrieve(this.user.username).then(response => {
          this.$store.commit("setUser", { user: response.data })
        })
      }
      // Trigger page refresh
      this.refresh()
    },
  }
}
</script>

<style lang="scss" scoped>
#app {
  background: #616161 url('/images/topography.svg') center center fixed !important;
  background-size: auto;
}
</style>